import { Group, Pill, Text } from '@mantine/core';

import { Nomenclature } from '@feature/nomenclature';

interface BdiListProps {
  bdis: Nomenclature[];
}

export function BdiList({ bdis }: BdiListProps) {
  if (!bdis || bdis.length === 0) {
    return null;
  }

  return (
    <Group>
      <Text>Indexari bdi: </Text>
      {bdis.map(bdi => (
        <Pill
          bg="blue"
          c="white"
          key={bdi.name}
        >
          {bdi.name}
        </Pill>
      ))}
    </Group>
  );
}
